export class ArchiveJob {
  archiveJobId: string;
  caseId: string;
  title: string;
  comments: string;
  createdById: string;
  createdBy: string;
  dateTimeCreated: Date;
  runById: string;
  runBy: string;
  dateTimeRun?: Date;
  archiveBaseNumberStart: number;
  archiveBaseNumberDigits: number;
  isCreateTiff: boolean;
  docSizeArchived: string;
  totalDocCount: number;
  lifeCycle: number;
  status: ArchiveJobStatus;
}

export class ArchiveJobIdTitle {
	archiveJobId: string;
	title: string;
}

export enum ArchiveJobStatus {
  PreRun = 'PreRun',
  Queued = 'Queued',
  Running = 'Running',
  PostRun = 'PostRun'
}
